// src/components/ContextMenu.jsx
import { useEffect, useRef, useMemo } from "react";
import { useLocation } from "react-router-dom";
import rightClickInfoConfig, { getRouteConfig } from '../config/rightClickInfoConfig';

export default function ContextMenu({ x, y, featureInfo, onClose, showTourOption, onShowTour }) {
  const menuRef = useRef(null);
  const location = useLocation();
  
  // Get info from config for current route (supports exact match and pattern matching)
  const config = useMemo(() => getRouteConfig(location.pathname), [location.pathname]);
  const infoText = config?.info || featureInfo || 'No info available.';

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  return (
    <div
      ref={menuRef}
      className="fixed z-[99999] bg-white border border-gray-200 rounded-lg p-2 text-[14px] text-gray-800 min-w-[170px] max-w-[90vw] shadow-md animate-fade-in"
      style={{ top: y, left: x, maxWidth: 320 }}
    >
      <div className="flex items-center gap-1 mb-1">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#2563eb" opacity="0.12"/><path d="M12 8v4m0 4h.01" stroke="#2563eb" strokeWidth="2" strokeLinecap="round"/></svg>
        <span className="font-semibold text-gray-900 text-[13px]">Feature Info</span>
      </div>
      <div className="mb-2 text-gray-700 leading-snug break-words">{infoText}</div>
      {/* {showTourOption && (
        <button
          className="w-full text-left px-2 py-1 rounded bg-blue-50 hover:bg-blue-100 text-blue-700 font-medium transition-all border border-blue-100"
          onClick={onShowTour}
        >
          <span className="inline-block align-middle">🚀</span> <span className="align-middle">Show Tour</span>
        </button>
      )} */}
    </div>
  );
}
